<template>
  <div class="feedback-section">
    <div class="feedback-header">
      <p>编辑反馈</p>
    </div>
    <div class="feedback-main">
      <div class="select-form">
        <el-form
          style="font-size: 12px;"
          label-width="80px"
          size="mini"
          :model="feedback"
          ref="feedback"
          :rules="Rule"
        >
          <el-form-item prop="courseware_id" label="选择课件">
            <el-select
              v-model="feedback.courseware_id"
              placeholder="请选择课件"
              @change="handleChangeCourseware"
              class="form-input"
            >
              <el-option
                v-for="item in coursewareList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              >
              </el-option>
            </el-select>
            <div class="Courseware-container" v-if="courseware.name">
              <img
                :src="courseware.image.file_src"
                alt=""
                class="courseware-image"
              />
              <div class="title">{{ courseware.name }}</div>
              <p class="desc">{{ courseware.content }}</p>
            </div>
          </el-form-item>
          <el-form-item label="反馈内容" prop="remarks">
            <el-input
              type="textarea"
              placeholder="填写您的反馈内容..."
              rows="6"
              v-model="feedback.remarks"
              class="form-textarea"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button class="save-button" @click="handleSubmit">保存</el-button>
      <el-button class="return-button" @click="() => this.$router.back()"
        >返回</el-button
      >
    </div>
  </div>
</template>
<script>
import classService from "@/global/service/class";
import userService from "@/global/service/user";
export default {
  data() {
    return {
      courseware: {},
      feedback: {
        courseware_id: null,
        remarks: ""
      },
      Rule: {
        courseware_id: {
          required: true,
          message: "请选择课件",
          trigger: "change"
        },
        remarks: [{ required: true, message: "请填写反馈", trigger: "blur" }]
      },
      coursewareList: [],
      gradeData: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleSubmit() {
      this.$refs.feedback.validate(valid => {
        if (valid) {
          const params = {
            courseware_id: this.feedback.courseware_id,
            remarks: this.feedback.remarks
          };
          userService.coursewareFeedBackCreate(params).then(() => {
            this.$message.success("反馈成功");
            this.$router.push({
              name: "my_feedback"
            });
          });
        }
      });
    },
    getData() {
      classService.coursewareList().then(res => {
        this.coursewareList = res.list;
      });
    },
    handleChangeCourseware(e) {
      classService.coursewareDetail(e).then(res => {
        this.courseware = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.feedback-section {
  color: #2c3e50;
  font-size: 12px;
  .feedback-header {
    display: flex;
    align-items: center;
    background: #ffffff;
    height: 40px;
    padding-left: 20px;
  }
  .feedback-main {
    margin-top: 10px;
    background: #ffffff;
    text-align: left;
    padding-bottom: 20px;
    .select-form {
      padding-top: 20px;
      padding-left: 20px;
      .el-form {
        .el-form-item {
          width: 48%;
        }
      }
    }
  }
  .form-input {
    width: 230px;
  }
  .form-textarea {
    width: 500px;
  }
  .Courseware-container {
    margin-top: 20px;
    width: 230px;
    .courseware-image {
      width: 230px;
      height: 160px;
      object-fit: cover;
    }
    .title {
      font-size: 14px;
      color: #333;
      line-height: 30px;
      border-bottom: 1px solid #dedede;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .desc {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-top: 10px;
      font-size: 12px;
      color: #666666;
    }
  }
  .return-button {
    font-size: 12px;
    width: 56px;
    height: 32px;
    padding: 0;
    color: #f0b32f;
    border: 1px solid #f0b32f;
  }
  .save-button {
    font-size: 12px;
    width: 56px;
    height: 32px;
    padding: 0;
    color: #ffffff;
    background: #f0b32f;
    margin-left: 100px;
  }
}

/deep/.el-form-item__content {
  text-align: left;
}
</style>
